import React from "react";

export default function Tools() {
  return (
    <div>
      <p>Tools</p>
    </div>
  );
}
